
type Props = {
  key: number;
};

const IntegrationSkeleton = ({key}: Props) => {
  return (
    <div className="bg-white rounded-lg p-4 2xl:flex items-start gap-4 animate-pulse border" key={`val${key}`}>
  <div className="flex-shrink-0">
    <div className="w-16 h-16 bg-gray-200 rounded-lg" />
  </div>
  <div className="space-y-2 flex-1 mt-1">
    <div className="space-y-1">
      <div className="w-40 h-4 bg-gray-200 rounded" />
      <div className="w-54 h-3 bg-gray-200 rounded" />
    </div>
    <div className="flex gap-3">
      <div className="w-20 h-8 bg-gray-200 rounded-md" />
      <div className="w-20 h-8 bg-gray-200 rounded-md" />
    </div>
  </div>
</div>
  )
}

export default IntegrationSkeleton
